import Main from "../Main";
import ServerJsonResponse from "@/ts/base/Interfaces/ServerJsonResponse";

export default class SearchAutoComplete {
	protected input: HTMLInputElement;
	protected form: HTMLFormElement | null = null;
	protected menu!: HTMLUListElement;
	protected isLoading: boolean = false;

	protected timeouot: number = 0;

	constructor(inputSelector: string = "input[type=search]", form?: HTMLFormElement) {
		if (form) {
			this.form = form;
			this.form.classList.add("has-autocomplete")
			this.input = this.form.querySelector(inputSelector) as HTMLInputElement;
		}
		else {
			this.input = document.querySelector(inputSelector) as HTMLInputElement;
		}

		if (!this.input) {
			return;
		}

		this.menu = this.createDropdown();
		this.input.after(this.menu);
		this.input.classList.add("is-autocomplete");

		this.input.addEventListener("input", this.onSearch.bind(this));
		document.body.addEventListener("click", this.onClickOutside.bind(this));
	}

	async search(query: string) {
		this.setLoading(true);

		const data = new FormData(this.form || undefined);
		data.append("term", query);
		data.append("action", "AutoComplete/GetPostTitles");

		const resp = await fetch(Main.Instance.options.url.ajax, {
			body: data,
			method: "POST",
			credentials: "same-origin",
			headers: {
				Accept: "application/json",
			},
		});

		const list = <ServerJsonResponse<string[]>>await resp.json();
		let showDropdown = true;

		if (list.success && list.data) {
			this.addDropdownItems(list.data);
		}
		else if (list.errorMessage) {
			this.addErrorMessage(list.errorMessage)
		}
		else {
			showDropdown = false;
		}

		if (showDropdown) {
			this.setLoading(!showDropdown);
		}
	}

	protected addDropdownItems(list: string[]): void {
		list.forEach(i => {
			const li = document.createElement("li") as HTMLLIElement;
			li.innerHTML = i;

			this.menu.append(li);
		});
	}

	protected addErrorMessage(msg: string): void {
		const li = document.createElement("li") as HTMLLIElement;
		li.classList.add("no-result");
		li.innerHTML = msg;

		this.menu.append(li);
	}

	protected createDropdown(): HTMLUListElement {
		const ul = document.createElement("ul");
		ul.classList.add("dropdown-menu");
		ul.style.top = this.input.clientHeight + "px";

		return ul;
	}

	protected setLoading(value: boolean): void {
		if (value) {
			this.showDropdown(false);
			this.menu.innerHTML = "";
			this.input.classList.add("loading");
		}
		else {
			this.input.classList.remove("loading");
			this.showDropdown(true);
		}

		this.isLoading = value;
	}

	protected showDropdown(value: boolean): void {
		if (value) {
			this.menu.classList.add("show");
		}
		else {
			this.menu.classList.remove("show");
		}
	}

	protected onSearch(e: Event): void {
		window.clearTimeout(this.timeouot);

		this.timeouot = window.setTimeout(() => {
			if (this.input.value.length > 1 && !this.isLoading) {
				this.search(this.input.value).finally();
			}
			else {
				this.showDropdown(false);
			}
		}, 300);
	}

	protected onClickOutside(e: Event): void {
		const target = e.target as HTMLElement;

		if (!target.isEqualNode(this.input)) {
			this.showDropdown(false);
		}
	}
}
